import { takeLatest, put } from 'redux-saga/effects';
import {
    GET_CALENDAR_PLAYERS,
    DELETE_USER_PLAYER,
    PSEUDONONYMIZE_USER_PLAYER,
    SET_CALENDAR_FILTER_PLAYER,
    SEND_CALENDAR_ADVERTISING_CLICK,
    DOWNLOAD_EXPORT_FILE,
    DELETE_CALENDAR_ALL_USER_PLAYERS
} from './constants';
import {
    requestCalendarPlayers,
    requestDeleteUserPlayer,
    requestPseudononymizeUserPlayer,
    requestCalendarPlayersFilter,
    requestSendClickAdvertising,
    requestExportFile,
    requestCalendarDeleteAllUserPlayer
} from './api';
import {
    getCalendarPlayersSuccess,
    deleteUserPlayerSuccess,
    pseudononymizeUserPlayerSuccess,
    setCalendarFilterSuccess,
    downloadExportFileSuccess,
    deleteCalendarAllUserPlayersSuccess
} from './actions';

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{players, type}>>}
 */
function* getCalendarPlayers( obj ) {
    const players = yield requestCalendarPlayers( obj.id );
    if ( players ) {
        yield put( getCalendarPlayersSuccess( players ) );
    }
}

/**
 *
 * @param obj
 * @returns {IterableIterator<PutEffect<{players, type}>>}
 */
function* setCalendarPlayersFilter( obj ) {
    const players = yield  requestCalendarPlayersFilter( obj.calendarID, obj.from, obj.to, obj.hatchId );

    if ( players ) {
        yield put( setCalendarFilterSuccess( players ) );
    }

}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{players, type}>>}
 */
function* deleteUserPlayer( actionObj ) {
    const player = yield requestDeleteUserPlayer( actionObj.id, actionObj.calendarID, actionObj.from, actionObj.to, actionObj.hatchId );
    if ( player ) {
        yield put( deleteUserPlayerSuccess( player ) );
    }
}

function* pseudononymizeUserPlayer( actionObj ) {
    const player = yield requestPseudononymizeUserPlayer( actionObj.player_id, actionObj.calendar_id);
    if ( player ) {
        yield put( pseudononymizeUserPlayerSuccess( player ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<*>}
 */
function* sendPlayerAdvertisingClcik( actionObj ) {
    const resp = yield requestSendClickAdvertising( actionObj.itemType, actionObj.hatchId, actionObj.link );
    if ( resp ) {
        // yield put(deleteUserPlayerSuccess(player))
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{file, type}>>}
 */
function* downloadExportFile( actionObj ) {
    const file = yield requestExportFile( actionObj.calendarID, actionObj.hatchId );
    if ( file ) {
        yield put( downloadExportFileSuccess( file ) );
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{players, type}>>}
 */
function* deleteCalendarAllUserPlayers( actionObj ) {
    const players = yield requestCalendarDeleteAllUserPlayer( actionObj.calendarID, actionObj.typeData, actionObj.withPlayers, actionObj.resolve );
    if ( players ) {
        yield put( deleteCalendarAllUserPlayersSuccess( players ) );
    }
}


function* watchCalendarPlayers() {
    yield takeLatest( GET_CALENDAR_PLAYERS, getCalendarPlayers );
    yield takeLatest( DELETE_USER_PLAYER, deleteUserPlayer );
    yield takeLatest( PSEUDONONYMIZE_USER_PLAYER, pseudononymizeUserPlayer );
    yield takeLatest( SET_CALENDAR_FILTER_PLAYER, setCalendarPlayersFilter );
    yield takeLatest( SEND_CALENDAR_ADVERTISING_CLICK, sendPlayerAdvertisingClcik );
    yield takeLatest( DOWNLOAD_EXPORT_FILE, downloadExportFile );
    yield takeLatest( DELETE_CALENDAR_ALL_USER_PLAYERS, deleteCalendarAllUserPlayers )
}


export default watchCalendarPlayers;